import styled from "styled-components";

const Question = styled.h3`
  margin-bottom: 24px;
`;

const Section = styled.div``;

const Stage = styled.span`
  color: #ce93d8;
  font-weight: 600;
`;

const Positive = styled.span`
  color: #ce93d8;
`;
const Negative = styled.span`
  color: #ffb74d;
`;

export { Negative, Positive, Question, Section, Stage };
